<template>
  <div class="enrolDateInputWrapper">
    <date-picker v-model="date"
                 v-bind:value="this.date"
                 v-bind:calendar-class="{rewardCouponStyle: isExpiredDate}"
                 v-bind:input-class="{enrollDatePickerStyle : true}"
                 v-bind:language="korean"
                 v-bind:format="'yyyy년 MM월 dd일'"
                 v-on:closed="dateSelected">
    </date-picker>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { ko } from 'vuejs-datepicker/dist/locale'

export default {
  props: {
    type: String
  },
  data () {
    return {
      date: null,
      korean: ko,
      isExpiredDate: false
    }
  },
  components: {
    'date-picker': Datepicker
  },
  methods: {
    dateSelected: function () {
      if(this.type === 'start') {
        this.$store.commit('setEnrollStateValue', {type: 'period', subType: this.type, startDate: this.date})
      }else if(this.type === 'end') {
        this.$store.commit('setEnrollStateValue', {type: 'period', subType: this.type, endDate: this.date})
      }else if(this.type === 'expiredDate') {
        this.$store.commit('setEnrollStateValue', {type: 'coupon', subType: this.type, value: this.date})
      }
    }
  },
  created: function () {
    // 기존에 EnrollState에 지정된 날짜가 있을 경우 날짜 설정
    let beforeDate = new Date()
    if(this.type === 'start') {
      beforeDate = this.$store.getters.getEnrollState.find(items => items.type === 'period').startDate
    }else if (this.type === 'end') {
      beforeDate = this.$store.getters.getEnrollState.find(items => items.type === 'period').endDate
    }else if (this.type === 'expiredDate') {
      beforeDate = this.$store.getters.getEnrollStateValue('coupon').expiredDate
    }
    this.date = beforeDate

    // reward 쿠폰의 날짜 선택의 경우 잘리지 않도록 선택창 위치 조절
    this.isExpiredDate = this.type === 'expiredDate'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.enrolDateInputWrapper{
  margin: 20px 20px 0 0;
}
</style>

<style>
.enrollDatePickerStyle{
  padding: 0 0 5px;
  font-size: 13px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px rgb(112,112,112) solid;
  width: 130px;
  outline: none;
  background-image: url('../../../assets/img/date_input_box_scroll_icon.png');
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position: 100% 50%;
}

.rewardCouponStyle{
  position: absolute;
  top: 22px;
  left: -180px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/enrollDateInput.vue